import { Component, OnInit } from '@angular/core';
import { DataService } from '@app-core/services/data/data.service';
import { LoginTypes } from '@app-core/services/google-tag-manager/google-tag-manager.service';
// import { StorageService } from '@app-core/services/storage/storage.service';
import { CLIENT_CONFIG } from '@config/config';
// import { GeotabSsoStorageMapping } from '@config/config.base';
import { IframeAuthService } from '../../services/iframe-auth/iframe-auth.service';
import { Router } from '@angular/router';
import { AccessService } from '@app-core/services/access/access.service';
import { environment } from '@env/environment';
import { SUPPORTED_LANGUAGES } from '@app-core/constants/constants';
import { GeotabApiService } from '../../services/geotab/geotab-api.service';
import { GeotabCredentials } from 'src/app/geotab/geotab-utils';

@Component({
  selector: 'app-geotab-login',
  templateUrl: './geotab-login.component.html',
  styleUrls: ['./geotab-login.component.scss'],
})
export class GeotabLoginComponent implements OnInit {
  constructor(
    // private storageService: StorageService,
    private dataService: DataService,
    private router: Router,
    private accessService: AccessService,
    private iframeAuthService: IframeAuthService,
    // private translate: TranslateService,
    private geotabApiService: GeotabApiService
  ) {}
  private supportedLanguage = SUPPORTED_LANGUAGES;
  private credentials: GeotabCredentials;

  public ngOnInit() {
    this.geotabApiService.getLoginData().subscribe({
      next: (resp) => {
        // todo - support all geotab dateformats
        // currently formats with spaces in the date are not supported
        if (resp && resp.result && resp.result.length > 0) {
          const userDate = resp.result[0];
          const timezone = userDate.timeZoneId;
          const language = userDate.language;

          this.accessService.currentTimeZone = timezone;
          this.dataService.currentTimeZone = timezone;

          this.accessService.currentLanguage = language;

          if (this.supportedLanguage.filter((el) => el.key === language).length) {
            this.dataService.currentLanguage = language;
          } else {
            this.dataService.currentLanguage = 'en';
          }

          let metricUnit = userDate.isMetric ? 'Kilometers' : 'Miles';
          this.accessService.currentMetricUnit = metricUnit;
          this.dataService.currentMetricUnit = metricUnit;
        }
      },
    });
    this.credentials = this.geotabApiService.getGeotabCredentials();

    const loginInfo = this.accessService.getLoginInfo();
    const currentFleet = loginInfo.fleets && loginInfo.fleets.length > 0 ? loginInfo.fleets[0].fleetId : null;

    if (!this.accessService.hasValidToken() || currentFleet !== this.credentials.database) {
      this.validateSSOState();
    } else {
      let redirectUrl: string;

      if (environment.production) redirectUrl = this.dataService.extractPageParameter(window.location.href);
      else redirectUrl = 'home';

      console.log('redirect URL', redirectUrl);

      if (redirectUrl) this.router.navigateByUrl(redirectUrl, { replaceUrl: true });
      else console.error('Redirect URL is missing or invalid');
    }
  }

  private validateSSOState() {
    const { userName = '', sessionId = '', database = '' } = this.credentials || {};
    if (userName && sessionId && database) {
      const body = { userName, sessionId, database, geotabBaseUrl: `https://${this.geotabApiService.getGeotabServer()}` };
      this.iframeAuthService.authenticateGeotabUser(CLIENT_CONFIG.clientName, body).subscribe(
        (res) => {
          const loginInfo = { ...res, loginType: 'fleetmanager' };
          let page = '';
          if (environment.production) page = this.dataService.extractPageParameter(window.location.href);
          else page = 'trips';

          this.dataService.userLogin.next({ loginInfo, redirectUrl: page, loginType: LoginTypes.sso });
        },
        () => {
          this.iframeAuthService.logout();
        }
      );
    } else {
      this.iframeAuthService.redirectToLoginPage();
    }
  }
}
